import httpInstances from '@/api/axiosInstance';
import { toQueryParams } from '@/utils/toQueryParams';

import { FeedInfo } from '../types';

const group = import.meta.env.VITE_FEED_GROUP;
export type FeedFilters = { KeyCategory?: string; KeyValue?: string };

export const fetchFeedData = async (metadata?: FeedFilters): Promise<FeedInfo[]> => {
  const params = toQueryParams({
    group,
    from: '30d',
    'field.Status': 'Live',
    ...metadata
  });
  const { data }: { data: FeedInfo[] } = await httpInstances.axiosDataInstance.get(
    `index${params}`,
    {
      headers: {
        Accept: 'application/json'
      }
    }
  );
  return data.map(feedInfo => {
    const transactionTime = feedInfo.transactionTime;
    return {
      ...feedInfo,
      transactionTime: transactionTime.includes('Z') ? transactionTime : `${transactionTime}Z`
    };
  });
};
